import { render, staticRenderFns } from "./BeneficiaryDetail.vue?vue&type=template&id=95a351b4&scoped=true&"
import script from "./BeneficiaryDetail.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a351b4",
  null
  
)

export default component.exports